import { render, staticRenderFns } from "./usersRecognitionsResume.vue?vue&type=template&id=fbf57ab6&scoped=true"
import script from "./usersRecognitionsResume.vue?vue&type=script&lang=js"
export * from "./usersRecognitionsResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf57ab6",
  null
  
)

export default component.exports